/**
 * CPG mobile-nav link fixups (2026-08-12). The mobile drawer's bottom link list
 * (.cp-mobile-drawer__links) is baked into the 178KB header section, so this makes two additive
 * DOM tweaks instead of editing that file:
 *   1. "See All Parts"  -> /pages/shop-all   (was /collections/)
 *   2. insert "Shop by Category" (/collections) and "Shop by Vehicle" (/pages/manufacturers)
 *      right after "See All Parts", before "Shop Brands".
 * Idempotent + graceful: no-ops if the drawer isn't present; re-runs if the drawer re-renders.
 */
(function () {
  'use strict';
  function inject() {
    var list = document.querySelector('.cp-mobile-drawer__links');
    if (!list) return false;
    var links = [].slice.call(list.querySelectorAll('a'));
    var seeAll = links.filter(function (a) { return /^\s*see all parts\s*$/i.test(a.textContent || ''); })[0];
    if (!seeAll) return false;

    // 1. point "See All Parts" at the Shop All page
    if (seeAll.getAttribute('href') !== '/pages/shop-all') seeAll.setAttribute('href', '/pages/shop-all');

    // 2. add the two links once (skip if a link with that label already exists)
    function has(label) {
      return [].slice.call(list.querySelectorAll('a')).some(function (a) {
        return (a.textContent || '').trim().toLowerCase() === label.toLowerCase();
      });
    }
    function make(label, href) {
      var a = seeAll.cloneNode(true);   // clone to inherit the drawer link styling/classes
      a.textContent = label;
      a.setAttribute('href', href);
      return a;
    }
    var anchor = seeAll.nextSibling;    // fixed insertion point (the element after See All Parts)
    if (!has('Shop by Category')) list.insertBefore(make('Shop by Category', '/collections'), anchor);
    if (!has('Shop by Vehicle')) list.insertBefore(make('Shop by Vehicle', '/pages/manufacturers'), anchor);
    return true;
  }

  if (!inject()) {
    var tries = 0;
    var iv = setInterval(function () { if (inject() || ++tries > 40) clearInterval(iv); }, 250);
  }
  // the drawer can be (re)built on open — re-run shortly after any tap
  document.addEventListener('click', function () { setTimeout(inject, 120); }, true);
})();
